/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteIssuanceProfileRequestBody,
  DeleteIssuanceProfileRequestBody$Outbound,
  DeleteIssuanceProfileRequestBody$outboundSchema,
} from "../components/deleteissuanceprofilerequestbody.js";

export type DeleteIssuanceProfileSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type DeleteIssuanceProfileRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  deleteIssuanceProfileRequestBody: DeleteIssuanceProfileRequestBody;
};

/** @internal */
export type DeleteIssuanceProfileSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const DeleteIssuanceProfileSecurity$outboundSchema: z.ZodMiniType<
  DeleteIssuanceProfileSecurity$Outbound,
  DeleteIssuanceProfileSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function deleteIssuanceProfileSecurityToJSON(
  deleteIssuanceProfileSecurity: DeleteIssuanceProfileSecurity,
): string {
  return JSON.stringify(
    DeleteIssuanceProfileSecurity$outboundSchema.parse(
      deleteIssuanceProfileSecurity,
    ),
  );
}

/** @internal */
export type DeleteIssuanceProfileRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  DeleteIssuanceProfileRequestBody: DeleteIssuanceProfileRequestBody$Outbound;
};

/** @internal */
export const DeleteIssuanceProfileRequest$outboundSchema: z.ZodMiniType<
  DeleteIssuanceProfileRequest$Outbound,
  DeleteIssuanceProfileRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    deleteIssuanceProfileRequestBody:
      DeleteIssuanceProfileRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      deleteIssuanceProfileRequestBody: "DeleteIssuanceProfileRequestBody",
    });
  }),
);

export function deleteIssuanceProfileRequestToJSON(
  deleteIssuanceProfileRequest: DeleteIssuanceProfileRequest,
): string {
  return JSON.stringify(
    DeleteIssuanceProfileRequest$outboundSchema.parse(
      deleteIssuanceProfileRequest,
    ),
  );
}
